module.exports = __webpack_public_path__ + "static/img/08.e345582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/08.jpg
// module id = q09G
// module chunks = 0